import { Platform } from "react-native";

const measures = {
  toolbarHeight: Platform.OS === "ios" ? 64 : 56,
};

export { measures };
